import { Swiper } from "swiper";
import { Navigation, Scrollbar } from "swiper/modules";
import Glider from "glider-js";

(function () {
  const sliders = document.querySelectorAll("[data-js-toplist-slider]");

  for (const slider of sliders) {
    const scrollbar = slider.querySelector("[data-js-toplist-scrollbar]");
    const prev = slider.querySelector("[data-js-toplist-prev]");
    const next = slider.querySelector("[data-js-toplist-next]");
    const isMobile = window.innerWidth < 768;

    if (isMobile) {
      new Glider(slider, {
        slidesToShow: "auto",
        slidesToScroll: "auto",
        itemWidth: "auto",
        resizeLock: false,
        draggable: true,
        skipTrack: true,
      });
    } else {
      new Swiper(slider, {
        modules: [Navigation, Scrollbar],
        slidesPerView: "auto",
        freeMode: true,
        loop: false,
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        scrollbar: {
          el: scrollbar,
        },
      });
    }
  }
})();
